import React from 'react';
import { ShieldIcon, TrendingUpIcon, UsersIcon } from 'lucide-react';
export const AboutSection = () => {
  return <section id="about" className="py-16 bg-white" data-id="element-11">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12">
        <div className="lg:text-center" data-id="element-13">
          <h2 className="text-base text-[#D4AF37] font-semibold tracking-wide uppercase" data-id="element-14">
            About Us
          </h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-slate-800 sm:text-4xl" data-id="element-15">
            A Legacy of Trust and Excellence
          </p>
          <p className="mt-4 max-w-2xl text-xl text-slate-600 lg:mx-auto" data-id="element-16">
            Founded with a mission to provide exceptional investment management
            for our close circle, we combine traditional wisdom with innovative
            strategies.
          </p>
        </div>
        <div className="mt-16" data-id="element-17">
          <div className="space-y-10 md:space-y-0 md:grid md:grid-cols-3 md:gap-x-8 md:gap-y-10" data-id="element-18">
            <div className="relative" data-id="element-19">
              <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-[#D4AF37] text-white" data-id="element-20">
                <ShieldIcon size={24} aria-hidden="true" data-id="element-21" />
              </div>
              <h3 className="ml-16 text-lg leading-6 font-medium text-slate-800" data-id="element-22">
                Trust & Security
              </h3>
              <div className="mt-2 ml-16 text-base text-slate-600" data-id="element-23">
                We treat every investment with the same care and diligence as
                our own, maintaining the highest standards of integrity and
                transparency.
              </div>
            </div>
            <div className="relative" data-id="element-24">
              <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-[#D4AF37] text-white" data-id="element-25">
                <TrendingUpIcon size={24} aria-hidden="true" data-id="element-26" />
              </div>
              <h3 className="ml-16 text-lg leading-6 font-medium text-slate-800" data-id="element-27">
                Strategic Growth
              </h3>
              <div className="mt-2 ml-16 text-base text-slate-600" data-id="element-28">
                Our investment philosophy balances growth opportunities with
                risk management for consistent, long-term results.
              </div>
            </div>
            <div className="relative" data-id="element-29">
              <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-[#D4AF37] text-white" data-id="element-30">
                <UsersIcon size={24} aria-hidden="true" data-id="element-31" />
              </div>
              <h3 className="ml-16 text-lg leading-6 font-medium text-slate-800" data-id="element-32">
                Family Focus
              </h3>
              <div className="mt-2 ml-16 text-base text-slate-600" data-id="element-33">
                Currently managing investments exclusively for family and close
                friends, with plans to expand our services in the future.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};